import api from '../../api/'
// import entites from '../../api/models/entites';
const state = {
    all:[],
    typesentite:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            id: '',
            nom_commercial: '',
            solde: '',
            telephone: '',
            typeentite_libelle: '',
            gerant: '',
            email: '',
            active: '',
            description: '',
            created_at: '',
            deleted_at: '',
            updated_at: '',
            btn:""
        }
        state.all.forEach(element => {           
            row = {
                id: element.id,
                nom_commercial: element.nom_commercial,
                solde: element.solde.toLocaleString(),
                telephone: element.telephone,
                typeentite_libelle: element.typeentite_libelle,
                gerant: element.gerant,
                email: element.email,
                active: element.active===1?'activée':'désactivée',
                description: element.description,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at
            }
            data.push(row)
        });
        return data;
    },
    types(state){
        let data = []
        let type = {
            libelle: ''
        }
        state.typesentite.forEach(element => {           
            type = {
                libelle: element             
            }
            data.push(type)
        });
        return data;
    },
}
const mutations= {
    setEntity(state, entities) {
        console.log(entities)
        state.all = entities
    },
    settypesentity(state, typesentities) {
        state.typesentite = typesentities
    },
    addEntity(state,entity){
        state.all.push(entity)
    }
}

const actions={
    get_all_entities({ commit }, serverParams){

        return api.entity.get_all_entites(serverParams).then((response)=>{
            console.log('reponse entite :',response)
            commit('setEntity', response.data.data.data)
            return response.data.data
        })
    },
    get_all_authentites({ commit }, serverParams){
        let tab_temp=[]
        return api.entity.get_all_authentites(serverParams).then((response)=>{

            tab_temp.push(response.data.data)
            commit('setEntity', tab_temp)
            tab_temp=[]
            return response.data.data
        })
    },
    get_all_typesentite({ commit }){
        return api.entity.get_all_typesentite().then((response)=>{          
            commit('settypesentity', response.data.data)
            return response.data.data
        })
    },
    post_entity({commit},entite){
        return api.entity.post_entites(entite).then((response)=>{
            commit('addEntity', response.data.data)
            return response.data
        })
        .catch(error => {
            return error.response.data
        })
    },
    put_entity({commit},data){
        return api.entity.put_entites(data.id,data.entity).then((response)=>{
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    show_entites({commit},id){
        return api.entity.show_entites(id).then((response)=>{
            return response.data.data;
        })
    },
    delete_entites({commit},id){
        return api.entity.delete_entites(id).then((response)=>{
            console.log(response.data)
            return response.data;
        })
        .catch(error => {
            return error.response.data
        })
    },
    active_entites({commit},id){
        return api.entity.active_entites(id).then((response)=>{
            console.log(response.data)
            return response.data;
        })
        .catch(error => {
            return error.response.data
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
